import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import { Tabs, Tab } from 'material-ui/Tabs'

import AppointmentTypes from './AppointmentTypes'
import BookingsCalendar from './BookingsCalendar'
import BookingPatients from './BookingPatients'

import {
  fetchApptTypes,
  patchApptType,
} from '../../state/actions/appointment-types'

const tabStyles = {
  tab: {
    backgroundColor: '#4acdde',
  },
  underline: {
    height: '4px',
    marginTop: '-4px',
    backgroundColor: '#797b7d',
  },
}

class OnlineScheduling extends Component {
  state = {
    currentSelectedTab: 'bookingsCalendar',
  }

  componentDidMount() {
    const { loadApptTypes } = this.props
    loadApptTypes()
  }

  toggleTabs = (value) => {
    this.setState({ currentSelectedTab: value })
  }

  render() {
    const { currentSelectedTab } = this.state
    const { activeLocation, hasDSO, hasPatientPortal, pmsType, hasNewPatientOS } = this.props
    return (
      <Tabs
        value={currentSelectedTab}
        onChange={this.toggleTabs}
        inkBarStyle={tabStyles.underline}
      >
        <Tab label="Calendar" value="bookingsCalendar" style={tabStyles.tab}>
          <BookingsCalendar {...this.props} />
        </Tab>
        <Tab label="Patients" value="bookingsPatients" style={tabStyles.tab}>
          <BookingPatients activeLocation={activeLocation} hasDSO={hasDSO} />
        </Tab>
        {(hasPatientPortal || (pmsType === 'Dolphin' && hasNewPatientOS)) && (
          <Tab
            label="Appointment Types"
            value="appointmentTypes"
            style={tabStyles.tab}
          >
            <AppointmentTypes {...this.props} />
          </Tab>
        )}
      </Tabs>
    )
  }
}

const mapStateToProps = ({
  account: {
    auth: { hasDSO, hasPatientPortal, pmsType, hasNewPatientOS },
    user: { activeLocation },
  },
  appointmentTypes: { apptTypeFetching, appointmentTypes },
}) => ({
  activeLocation,
  hasDSO,
  hasPatientPortal,
  pmsType,
  hasNewPatientOS,
  appointmentTypes,
  apptTypeFetching,
})

const mapDispatchToProps = dispatch => ({
  loadApptTypes: () => dispatch(fetchApptTypes(false)),
  patchAppointmentType: (apptId, apptVisibility, window) =>
    dispatch(patchApptType(apptId, apptVisibility, window)),
})

OnlineScheduling.propTypes = {
  activeLocation: PropTypes.shape({
    active: PropTypes.bool.isRequired,
    additional_recipients: PropTypes.arrayOf(PropTypes.object),
    city: PropTypes.string,
    country_code: PropTypes.string,
    created_at: PropTypes.string,
    doctor_id: PropTypes.string,
    earliest_same_day_reminder_hour: PropTypes.number,
    facebook_url: PropTypes.string,
    forwarding_email: PropTypes.string,
    google_url: PropTypes.string,
    id: PropTypes.string,
    latitude: PropTypes.number,
    longitude: PropTypes.number,
    name: PropTypes.string,
    office_email: PropTypes.string,
    office_phone: PropTypes.string,
    phone_numbers: PropTypes.arrayOf(PropTypes.object),
    practice_id: PropTypes.number,
    state: PropTypes.string,
    street_address: PropTypes.string,
    timezone: PropTypes.string,
    updated_at: PropTypes.string,
    website: PropTypes.string,
    yelp_url: PropTypes.string,
    zip: PropTypes.string,
  }),
  appointmentTypes: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      appointment_type_guid: PropTypes.string,
      practice_id: PropTypes.number,
      code: PropTypes.string,
      description: PropTypes.string,
      visibility: PropTypes.string,
      updated_at: PropTypes.string,
      created_at: PropTypes.string,
      online_scheduling: PropTypes.bool,
    }),
  ),
  hasDSO: PropTypes.bool.isRequired,
  pmsType: PropTypes.string.isRequired,
  hasNewPatientOS: PropTypes.bool.isRequired,
  hasPatientPortal: PropTypes.bool.isRequired,
  loadApptTypes: PropTypes.func,
  loading: PropTypes.bool,
  patchAppointmentType: PropTypes.func,
}

export default connect(mapStateToProps, mapDispatchToProps)(OnlineScheduling)



// WEBPACK FOOTER //
// ./src/components/OnlineScheduling/index.js